import React from 'react';
import { Button } from './ui/button';
import { MessageCircle } from 'lucide-react';

export const Hero = () => {
  const handleWhatsAppClick = () => {
    window.open('https://wa.me/584225997721', '_blank');
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-[#0F172A] pt-20">
      {/* Animated Background Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 left-10 w-72 h-72 bg-[#25D366]/10 rounded-full blur-3xl animate-pulse-slow"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl animate-pulse-slower"></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 py-20 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="text-center lg:text-left space-y-8 animate-fade-in-up">
            <h1 className="text-5xl lg:text-6xl font-bold text-white leading-tight">
              Asistentes de IA que te{' '}
              <span className="text-[#25D366]">resuelven la vida</span> por WhatsApp
            </h1>
            
            <p className="text-lg text-white/70 max-w-xl mx-auto lg:mx-0">
              Conoce a tu nuevo equipo de expertos digitales diseñados para quitarte 
              los dolores de cabeza del día a día.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <Button 
                size="lg"
                className="bg-[#25D366] hover:bg-[#20BD5A] text-white font-semibold text-lg px-8 py-6 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105"
                onClick={handleWhatsAppClick}
              >
                <MessageCircle className="mr-2 h-5 w-5" />
                Prueba a Lucas 💸
              </Button>
            </div>

            {/* Trust Indicators */}
            <div className="flex items-center gap-8 justify-center lg:justify-start pt-4">
              <div className="text-center">
                <div className="text-2xl font-bold text-white">100%</div>
                <div className="text-sm text-white/60">Venezolano</div>
              </div>
              <div className="h-12 w-px bg-white/20"></div>
              <div className="text-center">
                <div className="text-2xl font-bold text-white">24/7</div>
                <div className="text-sm text-white/60">Disponible</div>
              </div>
              <div className="h-12 w-px bg-white/20"></div>
              <div className="text-center">
                <div className="text-2xl font-bold text-white">IA</div>
                <div className="text-sm text-white/60">Avanzada</div>
              </div>
            </div>
          </div>

          {/* Right Image */}
          <div className="relative animate-fade-in-right">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl transform hover:scale-105 transition-transform duration-500">
              <img 
                src="https://images.pexels.com/photos/32021560/pexels-photo-32021560.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
                alt="AI Assistant Chat Interface"
                className="w-full h-auto"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0F172A]/60 to-transparent"></div>
            </div>
            
            {/* Floating Card */}
            <div className="absolute -bottom-6 -left-6 bg-white/10 backdrop-blur-md rounded-xl p-4 border border-white/20 animate-float">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-full bg-[#25D366] flex items-center justify-center">
                  <MessageCircle className="text-white h-6 w-6" />
                </div>
                <div>
                  <div className="text-white font-semibold text-sm">Lucas está activo</div>
                  <div className="text-white/60 text-xs">Listo para ayudarte</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
